export const about = {
  title: "About this course",
  text:
    "We’ll use this UI UX design tool to create beautiful User Interfaces and engaging prototypes. Most importantly... we'll cover the client expectations of you as a new UX designer.\n" + 
    "This course is aimed at people new to design, new to User Experience design. Even if you’re not totally sure what UX really means, don’t worry. We’ll start right at the beginning and work our way through step by step.",
};

export const learn = {
  title: "What you will learn",
  items: [
    {
      title: "How to begin working as a UX Designer using Figma.",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis eget bibendum vestibulum integer vitae faucibus malesuada varius.",
    },
    {
      title: "How to use Figma for Essential UX Design & UI Design",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis eget bibendum vestibulum integer vitae faucibus malesuada varius.",
    },
    {
      title: "How to make fully interactive prototypes.",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis eget bibendum vestibulum integer vitae faucibus malesuada varius.",
    },
    {
      title: "How to work with a UX personas.",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis eget bibendum vestibulum integer vitae faucibus malesuada varius.",
    },
    {
      title: "You will be able to add UX designer to your CV.",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis eget bibendum vestibulum integer vitae faucibus malesuada varius.",
    },
    {
      title: "Build a UX project from beginning to end.",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis eget bibendum vestibulum integer vitae faucibus malesuada varius.",
    },
  ],
};
